// src/hooks/useScrollReveal.js
import { useEffect, useRef } from "react";

export function useScrollReveal(
  { root = null, rootMargin = "0px 0px -5% 0px", threshold = 0.2 } = {}
) {
  const ref = useRef(null);

  useEffect(() => {
    const el = ref.current;
    // If IntersectionObserver isn't available, just show the element
    if (!el || typeof IntersectionObserver === "undefined") {
      if (el) el.classList.add("is-visible");
      return;
    }

    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach((entry) => {
          if (entry.isIntersecting) {
            entry.target.classList.add("is-visible");
          } else {
            entry.target.classList.remove("is-visible");
          }
        });
      },
      { root, rootMargin, threshold }
    );

    observer.observe(el);

    return () => {
      observer.disconnect();
    };
  }, [root, rootMargin, threshold]);

  return ref;
}
